export default __webpack_public_path__ + "static/media/480_store05-it-mobile.3d344d60.png";